import { Pipe, PipeTransform } from '@angular/core';
import { toPlainText } from './math-text';

/**
 * Texte de question à plat, pour les endroits où rien ne se compose : attribut
 * `title`, `aria-label`, message d'une boîte de confirmation.
 *
 * Usage : `[title]="question.title | mathPlain"`
 */
@Pipe({ name: 'mathPlain', standalone: true })
export class MathPlainPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return toPlainText(value);
  }
}
